import { handleStatus500 } from 'api/Utility/HandleStatus500'
import AxiosConfig from 'api/Utility/AxiosInitializer'
import getToken from 'lib/authentication/GetToken'
import apiWrapper from 'api/Utility/ApiWrapper'

export const activateParticipant = async (id: string) => {
  const axios = AxiosConfig({ token: getToken() })
  const URL = `site_users/${id}/activate`
  const activateParticipantRequest = () => axios.put(URL)

  return apiWrapper({
    endPoint: activateParticipantRequest,
    errorFailureAction: handleStatus500,
  })
}
